exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-subscription[data-v-790ec4a4]{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;padding:5px;border:1px solid #D6D8DE;margin:10px 0;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.active-subscription .icon-close[data-v-790ec4a4]{cursor:pointer;position:absolute;right:0;top:0}.active-subscription[data-v-790ec4a4]:hover{border:1px solid #000}.auto-width[data-v-790ec4a4]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}\n", ""]);

// exports
